import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';

import { PlaceholderWrapper, PlaceholderBody, PlaceholderFooter } from '../../../grids/placeholders';
import PlaceholderImage from '../../../grids/placeholders/shipping-box.svg';
import { PATH_ENHANCED_RETURNS, STATUS_PROCESSING, useEnhancedReturnRouteMatch } from '../../../../../../store/returns/returns.helpers';

import messages from '../../../grids/placeholders/messages';

export const NoSsrCompletedReturnsPlaceholder = () => {
  const intl = useIntl();
  const history = useHistory();
  const { storeGuid } = useEnhancedReturnRouteMatch();

  const onGoToProcessing = useCallback(() => {
    history.push(`${PATH_ENHANCED_RETURNS}/${storeGuid}/${STATUS_PROCESSING}`);
  }, [history, storeGuid]);

  return (
    <PlaceholderWrapper>
      <img alt={intl.formatMessage(messages.noReturnsAltText)} src={PlaceholderImage} />
      <PlaceholderBody>
        <Text textType={TextType.H2} value={messages.noCompletedReturnsHeader} />
        <Text textType={TextType.Paragraph} value={messages.noCompletedReturnsDescription} />
      </PlaceholderBody>
      <PlaceholderFooter>
        <Button onClick={onGoToProcessing} theme='primary'>
          <FormattedMessage {...messages.goToProcessing} />
        </Button>
      </PlaceholderFooter>
    </PlaceholderWrapper>
  );
};
